const baseUrl = 'https://d-ela-api-apse2.elmodev.com';

window.CKEDITOR_BASEPATH = '/ckeditor/';
window.CKFINDER_BASEPATH = '/ckfinder/';

export default {
  api: {
    baseUrl,
    authorization: 'Api-Key K2L1XuVKvHbe8tPrLuV5mcHHKUWmkQoGBbFRrdUzp_c',
    enableBFF: true,
  },
  assetUrl: '{{SANDCASTLE_CDN}}',
  assetPath: '/assets/images/',
  assetJsPath: '/assets/js/',
  slideTemplatePath: '/content/media/slideTemplate/images/',
  learningModuleTemplatePath: `/assets/learning_module_template/`,
  baseName: '',
  ckFinderConnectorPath: `${baseUrl}/ckfc/ckfinder/connector`,
  getManifestURL: `${baseUrl}/get-manifest`,
  getNavigationURL: `${baseUrl}/bff/navigation`,
  getUserInfoURL: `${baseUrl}/bff/user`,
  getTokenURL: `${baseUrl}/oauth2-client/auth/check-token`,
  launchDarklyClientSideId: process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID,
  OldCBTOKEN: 'd27cfd44d40d37576bbdfefa8ef30556',
  OldCBURL: 'https://lcms.dev.elmodev.com',
  NextMenuUrl: 'https://hcm.cdn.elmodev.com/menu-next/main.js',
};
